// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"172af2f8","461":"3c0c9b1d","871":"10c26f30"}[chunkId] + ".css";
};